// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Пример стилей для CustomizeLayer (CustomizeLayer.css) */
.customize-layer-menu {
  position: fixed;
  max-height: 95vh;
  overflow-y: auto;
  width: 320px;
  bottom: 5%;
  right: 2%;

  background-color: var(--tg-theme-bg-color);
  padding: 10px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  border-radius: 12px;
  z-index: 1101;
  display: flex;
  flex-direction: column;
  align-items: center;

  transition: background-color 0.2s ease;

  overflow-x: hidden;
}

.customize-layer-menu.slider-active {
  background-color: transparent;
  text-shadow: 0px 0px 1px var(--tg-theme-bg-color), 0px 0px 1px var(--tg-theme-bg-color), 0px 0px 1px var(--tg-theme-bg-color);
}

.customize-layer-header {
  width: 93%;
  text-align: center;
  margin-bottom: 5px;
  display: flex;
  align-items: center
}


.layer-name-input {
  font-size: 20px;
  text-align: center;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid var(--tg-theme-hint-color);
}

.layer-title {
  color: var(--tg-theme-button-color);
  font-size: 24px;
  cursor: pointer;
}

.customize-layer-settings {
  width: 100%;
  margin-top: 10px;
}

.customize-layer-slider,
.customize-layer-select {
  width: 100%;
  border-radius: 8px;
}

.customize-layer-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/components/menus/layer/CustomizeLayer.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;;EAET,0CAA0C;EAC1C,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,sCAAsC;;EAEtC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6HAA6H;AAC/H;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb;AACF;;;AAGA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB","sourcesContent":["/* Пример стилей для CustomizeLayer (CustomizeLayer.css) */\r\n.customize-layer-menu {\r\n  position: fixed;\r\n  max-height: 95vh;\r\n  overflow-y: auto;\r\n  width: 320px;\r\n  bottom: 5%;\r\n  right: 2%;\r\n\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 10px;\r\n  box-shadow: 0 3px 10px rgba(0,0,0,0.2);\r\n  border-radius: 12px;\r\n  z-index: 1101;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  transition: background-color 0.2s ease;\r\n\r\n  overflow-x: hidden;\r\n}\r\n\r\n.customize-layer-menu.slider-active {\r\n  background-color: transparent;\r\n  text-shadow: 0px 0px 1px var(--tg-theme-bg-color), 0px 0px 1px var(--tg-theme-bg-color), 0px 0px 1px var(--tg-theme-bg-color);\r\n}\r\n\r\n.customize-layer-header {\r\n  width: 93%;\r\n  text-align: center;\r\n  margin-bottom: 5px;\r\n  display: flex;\r\n  align-items: center\r\n}\r\n\r\n\r\n.layer-name-input {\r\n  font-size: 20px;\r\n  text-align: center;\r\n  padding: 5px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--tg-theme-hint-color);\r\n}\r\n\r\n.layer-title {\r\n  color: var(--tg-theme-button-color);\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n.customize-layer-settings {\r\n  width: 100%;\r\n  margin-top: 10px;\r\n}\r\n\r\n.customize-layer-slider,\r\n.customize-layer-select {\r\n  width: 100%;\r\n  border-radius: 8px;\r\n}\r\n\r\n.customize-layer-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
